import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import pages from './pages';
const SignIn = React.lazy(() => import('../pages/SignIn'));

/** One route per entry in pages.tsx, plus a redirect for unknown paths. */
export default function PageRoutes() {
  return (
    <Switch>
      {pages.map((page) => (
        <ProtectedRoute
          key={page.path}
          path={page.path}
          exact={page.exact}
          authorizedGroups={page.authorizedGroups}
          component={page.component}
          unauthenticated={SignIn as unknown as undefined}
          requireAuth={page.requireAuth}
          unauthorized={undefined}
        />
      ))}
      <Route render={() => <Redirect to={pages[0].path} />} />
    </Switch>
  );
}
